export default __webpack_public_path__ + "static/media/Faculty.d16e9a11.jpeg";